import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const WorkQualityToExercise = {
  label: "工作性質 vs 運動管理",
  key: "WorkQualityToExercise",
  path: "BMI/WorkQualityToExercise",
  api: "TCS_V_BMIHESportV",
  render: (options) => <Diagram.BMI.WorkQualityToExercise {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "工作性質",
      field: "工作性質",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
